module.exports = __webpack_public_path__ + "img/book-shippment.ba03e964.svg";